// src/components/modules/ModuleForm.tsx
import React, { useState, useEffect } from "react";
import { createModule, updateModule, getModule } from "./ModuleApi"
import { useParams, useNavigate } from "react-router-dom";

interface ModuleFormProps {
  isEditMode?: boolean;
}

const ModuleForm: React.FC<ModuleFormProps> = ({ isEditMode = false }) => {
  const [form, setForm] = useState({
    name: "",
    description: "",
    status: true,
  });

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (isEditMode && id) {
      getModule(id).then(res => setForm(res.data));
    }
  }, [id, isEditMode]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;
  
    // Narrow the type for checkbox
    if (type === "checkbox" && "checked" in e.target) {
      const checkbox = e.target as HTMLInputElement;
      setForm(prev => ({
        ...prev,
        [name]: checkbox.checked,
      }));
    } else {
      setForm(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isEditMode && id) {
      await updateModule(id, form);
    } else {
      await createModule(form);
    }
    navigate("/admin/modules");
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow-md max-w-xl mx-auto">
      <h2 className="text-xl font-semibold mb-4">
        {isEditMode ? "Edit Module" : "Create Module"}
      </h2>

      <div className="mb-4">
        <label className="block font-medium text-gray-700 mb-1">Name</label>
        <input
          name="name"
          value={form.name}
          onChange={handleChange}
          className="w-full border border-gray-300 p-2 rounded"
          required
        />
      </div>

      <div className="mb-4">
        <label className="block font-medium text-gray-700 mb-1">Description</label>
        <textarea
          name="description"
          value={form.description}
          onChange={handleChange}
          className="w-full border border-gray-300 p-2 rounded"
        />
      </div>

      <div className="mb-4 flex items-center">
        <input
          name="status"
          type="checkbox"
          checked={form.status}
          onChange={handleChange}
          className="mr-2"
        />
        <label className="text-gray-700">Active</label>
      </div>

      <button
        type="submit"
        className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
      >
        {isEditMode ? "Update" : "Create"}
      </button>
    </form>
  );
};

export default ModuleForm;